<template>
  <v-alert type="info" variant="tonal" icon="mdi-map-marker-off-outline">{{ message }}</v-alert>
</template>
<script lang="ts" setup>
defineProps<{ message: string }>()
</script>
